import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const AvatarUploaderFileSelector = props => {
  const { size, onChange, onBeforeChange } = props;
  const refInput = useRef();

  const handleChange = e => {
    onBeforeChange && typeof onBeforeChange === 'function' && onBeforeChange(e);

    if (e.target.value !== '') {
      onChange(e);
    }
  };

  return (
    <div className="avatar-uploader__form">
      <div
        className="avatar-uploader__placeholder"
        style={{
          width: size,
          height: size,
        }}
        onClick={() => refInput.current.click()}
      >
        - select image -
      </div>

      <input
        ref={refInput}
        type="file"
        hidden
        onChange={handleChange}
        accept=".png, .jpg, .jpeg"
      />
    </div>
  );
};

AvatarUploaderFileSelector.propTypes = {
  size: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onBeforeChange: PropTypes.func,
};

export default AvatarUploaderFileSelector;
